import { createContext } from 'react'
import { Flow } from '../types'

export const FlowContext = createContext<Flow>(null)
